// extracted by mini-css-extract-plugin
module.exports = {"heading":"heading__25kPb"};